/**
 * Colours live in CSS (src/styles/theme.css) so there is one source of truth.
 * Canvas needs real strings, so we resolve the custom properties at runtime.
 */

export interface Crayon {
  token: string;
  label: string;
}

/**
 * Six crayons, not twelve. They fit on a phone without scrolling, every one is
 * a colour a child can name, and a small box makes a picture look composed
 * instead of like a swatch chart.
 */
export const CRAYONS: Crayon[] = [
  { token: '--crayon-ink', label: 'Black' },
  { token: '--crayon-red', label: 'Red' },
  { token: '--crayon-yellow', label: 'Yellow' },
  { token: '--crayon-green', label: 'Green' },
  { token: '--crayon-blue', label: 'Blue' },
  { token: '--crayon-purple', label: 'Purple' },
];

const cache = new Map<string, string>();

/** Resolve a CSS custom property to a colour string usable by canvas. */
export function token(name: string): string {
  const hit = cache.get(name);
  if (hit) return hit;
  if (typeof document === 'undefined') return '#000000';
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  const resolved = value || '#000000';
  cache.set(name, resolved);
  return resolved;
}

/** Drop cached lookups — call after a theme change. */
export function clearTokenCache(): void {
  cache.clear();
}

export function crayonColors(): string[] {
  return CRAYONS.map((c) => token(c.token));
}

/** Confetti may use the wider box — it is a moment, not a choice. */
export function partyColors(): string[] {
  return ['--crayon-red', '--crayon-yellow', '--crayon-sky', '--crayon-purple', '--crayon-green', '--crayon-orange'].map(token);
}
